import {
  type QuestionCreationWorkflowStepCode,
  QuestionCreationWorkflowStepCodeObject,
} from '@exam-management/task-management';
import { Tab, TabContext, TabList } from '@shared/components';

import { useQuestionCreationTaskListSearchParams } from '../../hooks';

// NOTE: This generic type is used for the type accept Type and contains string type for type context
interface TabItem<TValue extends string = string> {
  value: TValue;
  label: string;
}

type QuestionCreationTaskStatusTabValues = QuestionCreationWorkflowStepCode | 'ALL';

const TAB_LIST: TabItem<QuestionCreationTaskStatusTabValues>[] = [
  {
    value: 'ALL',
    label: 'All',
  },
  {
    value: QuestionCreationWorkflowStepCodeObject.QuestionCreationTodo,
    label: 'Todo',
  },
  {
    value: QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress,
    label: 'In Progress',
  },
  {
    value: QuestionCreationWorkflowStepCodeObject.QuestionCreationDone,
    label: 'Done',
  },
];

export default function QuestionCreationTaskStatusFilter() {
  const [{ code }, { changeCode }] = useQuestionCreationTaskListSearchParams();

  const handleClick = (value: QuestionCreationTaskStatusTabValues) => {
    changeCode(value);
  };

  return (
    <TabContext value={code}>
      <TabList
        sx={{
          gap: 0,
          '& .MuiTabs-flexContainer': {
            gap: 0,
          },
        }}
      >
        {TAB_LIST.map((tab) => {
          return (
            <Tab
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(0),
                p: theme.spacing(4, 4, 0, 4),
                minWidth: 'unset',
              })}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
